import { RouteObject } from "react-router";

export const EstimateModalRoutes: RouteObject[] = [
  { path: "price_presentation" },
  { path: "homevest" },
  { path: "email_order_csv" },
  { path: "manual_trigger" },
];
